export default "__VITE_ASSET__CZ_mH3fI__"